module.exports = __webpack_public_path__ + "svg/angle-down.svg?2745f45339bee513b6e7141c3a75e8d0";